import React from 'react'
export default class FormRow extends React.PureComponent {
  render() {
    return <div className="form-row">{this.props.children}</div>
  }
}
